/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Series_FatigueInputs */

const en_ui_chart_series_fatigue = /** @type {(inputs: Ui_Chart_Series_FatigueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatigue (ATL)`)
};

const de_ui_chart_series_fatigue = /** @type {(inputs: Ui_Chart_Series_FatigueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ermüdung (ATL)`)
};

/**
* | output |
* | --- |
* | "Fatigue (ATL)" |
*
* @param {Ui_Chart_Series_FatigueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_series_fatigue = /** @type {((inputs?: Ui_Chart_Series_FatigueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Series_FatigueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_series_fatigue(inputs)
	return de_ui_chart_series_fatigue(inputs)
});